// import '../App.css';

import classes from './YesNoPopup.module.css';
import '../css_styles/button_styles.css'



function InfoPopup(props) {
    return (
    <div className = {classes.yes_no_popup} style = { {marginTop: props.ypos} } >
          <div style = {{height: 'min-content', marginTop: '20px', marginBottom: '20px', width:'80%', textAlign: 'center', position: 'relative', left: '50%', transform: 'translate(-50%,0% )'}}>
                {props.children}
              <div className = {classes.buttonContainer} >
                <button className={'tableButton'} onClick={props.handleOk}>ok</button>
              </div>
         </div>
    </div>
    );
}

export default InfoPopup;

